import { ResponseAccettazioneDatamatrix, ResponseConfirmClientAcceptance, ResponseConfirmCodiceBusta, ResponseEtichettaLottomatica, ResponseEtichettaWebApp } from "../../interfaces/response-confirm-client-acceptance";
import { createAction, props } from '@ngrx/store';
import { IParcelData } from '../../interfaces/response-verify-delivery';
import {
  IPayloadRifiutaPacco,
  IResponseRifiutaPacco,
} from '../../interfaces/rifiuta-pacco';
import {
  IPayloadPaccoSmarrito,
  IResponsePaccoSmarrito,
} from '../../interfaces/pacco-smarrito';
import { ISaleData } from '../../interfaces/response-verify-sale';
import {
  IParcelSale,
  IPayloadParcelSale,
} from '../../interfaces/response-parcel-sale';
import { IPayloadVerificaAccettazioneStampaPaperless, IResponseVerificaAccettazioneStampaPaperless } from "../../interfaces/verifica-accettazione-stampa-paperless";

export const RETRIEVE_VERIFY_DELIVERY = createAction(
  '[CLIENT-ACTIVITIES] - retrieve verify delivery',
  props<{ pin: string }>()
);

export const RETRIEVE_VERIFY_DELIVERY_SUCCESS = createAction(
  '[CLIENT-ACTIVITIES] - retrieve verify delivery success',
  props<{ responseVerifyDelivery: IParcelData | null }>()
);

export const RETRIEVE_VERIFY_DELIVERY_NO_PIN = createAction(
  '[CLIENT-ACTIVITIES] - retrieve verify delivery no pin',
  props<{ parcelCode: string }>()
);

export const RETRIEVE_VERIFY_DELIVERY_NO_PIN_SUCCESS = createAction(
  '[CLIENT-ACTIVITIES] - retrieve verify delivery no pin success',
  props<{ responseVerifyDeliveryNoPin: IParcelData | null }>()
);

export const RETRIEVE_RIFIUTA_PACCO = createAction(
  '[CLIENT-ACTIVITIES] - retrieve rifiuta pacco',
  props<{ payload: IPayloadRifiutaPacco }>()
);

export const RETRIEVE_RIFIUTA_PACCO_SUCCESS = createAction(
  '[CLIENT-ACTIVITIES] - retrieve rifiuta pacco success',
  props<{ responseRifiutaPacco: IResponseRifiutaPacco | null }>()
);

export const RETRIEVE_CONSEGNA_PACCO = createAction(
  '[CLIENT-ACTIVITIES] - retrieve consegna pacco',
  props<{ payload: IPayloadRifiutaPacco }>()
);

export const VERIFICA_ACCETTAZIONE_STAMPA_PAPERLESS = createAction(
  '[CLIENT-ACTIVITIES] - verifica accettazione stampa paperless',
  props<{ payload: IPayloadVerificaAccettazioneStampaPaperless }>()
);

export const VERIFICA_ACCETTAZIONE_STAMPA_PAPERLESS_SUCCESS = createAction(
  '[CLIENT-ACTIVITIES] - verifica accettazione stampa paperless success',
  props<{ responseVerificaAccettazioneStampaPaperless: IResponseVerificaAccettazioneStampaPaperless }>()
);

export const RETRIEVE_PACCO_SMARRITO = createAction(
  '[CLIENT-ACTIVITIES] - retrieve pacco smarrito',
  props<{ payload: IPayloadPaccoSmarrito }>()
);

export const RETRIEVE_CONSEGNA_PACCO_SUCCESS = createAction(
  '[CLIENT-ACTIVITIES] - retrieve consegna pacco success',
  props<{ responseConsegnaPacco: IResponseRifiutaPacco | null }>()
);

export const RETRIEVE_VERIFY_SALE = createAction(
  '[CLIENT-ACTIVITIES] - retrieve verify sale',
  props<{ code: string }>()
);

export const RETRIEVE_VERIFY_SALE_SUCCESS = createAction(
  '[CLIENT-ACTIVITIES] - retrieve verify sale success',
  props<{ responseVerifySale: ISaleData | null }>()
);

export const RETRIEVE_PARCEL_SALE = createAction(
  '[CLIENT-ACTIVITIES] - retrieve parcel sale',
  props<{ payload: IPayloadParcelSale }>()
);

export const RETRIEVE_PARCEL_SALE_SUCCESS = createAction(
  '[CLIENT-ACTIVITIES] - retrieve parcel sale success',
  props<{ responseParcelSale: IParcelSale | null }>()
);

export const RETRIEVE_PACCO_SMARRITO_SUCCESS = createAction(
  '[CLIENT-ACTIVITIES] - retrieve pacco smarrito success',
  props<{ responsePaccoSmarrito: IResponsePaccoSmarrito | null }>()
);

export const RETRIEVE_CONFIRM_CLIENT_ACCEPTANCE = createAction(
  '[CLIENT-ACTIVITIES] - retrieve confirm client acceptance',
  props<{ boxCode: string }>()
);

export const RETRIEVE_CONFIRM_CLIENT_ACCEPTANCE_SUCCESS = createAction(
  '[CLIENT-ACTIVITIES] - retrieve confirm client acceptance success',
  props<{
    responseConfirmClientAcceptance: ResponseConfirmClientAcceptance | null;
  }>()
);

export const RETRIEVE_CONFIRM_CLIENT_ACCEPTANCE_DATAMATRIX = createAction(
  '[CLIENT-ACTIVITIES] - retrieve confirm client acceptance datamatrix',
  props<{ dataMatrix: string}>()
);

export const RETRIEVE_CONFIRM_CLIENT_ACCEPTANCE_DATAMATRIX_SUCCESS = createAction(
  '[CLIENT-ACTIVITIES] - retrieve confirm client acceptance datamatrix success',
  props<{ responseConfirmClientAcceptanceDatamatrix: ResponseAccettazioneDatamatrix | null }>()
);

export const RETRIEVE_ETICHETTE_WEBAPP = createAction(
  '[CLIENT-ACTIVITIES] - retrieve etichette webApp'
);

export const RETRIEVE_ETICHETTE_WEBAPP_SUCCESS = createAction(
  '[CLIENT-ACTIVITIES] - retrieve etichette webApp success',
  props<{ responseEtichettaWebApp: ResponseEtichettaWebApp | null }>()
);

export const RETRIEVE_ETICHETTE_LOTTOMATICA = createAction(
  '[CLIENT-ACTIVITIES] - retrieve etichette lottomatica'
);

export const RETRIEVE_ETICHETTE_LOTTOMATICA_SUCCESS = createAction(
  '[CLIENT-ACTIVITIES] - retrieve etichette lottomatica success',
  props<{ responseEtichettaLottomatica: ResponseEtichettaLottomatica | null }>()
);

export const RETRIEVE_CONFIRM_CODICE_BUSTA = createAction(
  '[CLIENT-ACTIVITIES] - retrieve codice busta',
  props<{codiceBusta: string}>()
);

export const RETRIEVE_CONFIRM_CODICE_BUSTA_SUCCESS = createAction(
  '[CLIENT-ACTIVITIES] - retrieve codice busta success',
  props<{ responseConfirmCodiceBusta: ResponseConfirmCodiceBusta | null }>()
);